<template lang="pug">
  #ReservationIndex
    b-card.rounded-0.mb-3(
      bg-variant="light",
      no-body
    )
      b-card-body.py-2.px-3(
        class="searchArea"
      )
        .position-relative
          h5.text-center 我的預約
          i.fas.fa-angle-up.fa-lg.searchArea__iconArrow(
            v-b-toggle.collapse-searchBody
          )
        b-collapse#collapse-searchBody(
          visible
        )
          b-form-group.mb-2(
            label="顧客姓名："
          )
            b-input-group
              b-form-input(
                v-model="searchInput.customer_name",
                placeholder="請輸入顧客姓名"
              )
          b-form-group.mb-3(
            label="預約日期："
          )
            b-input(
              v-model="searchInput.reservation_date"
              type="date",
              placeholder="預約日期"
            )
          .row.no-gutters
            .col-6.pr-1
              b-button(
                variant="primary",
                block,
                @click="researtSearchHandler()"
              ) 重置
            .col-6.pl-1
              b-button(
                variant="primary",
                block,
                @click="searchHandler()"
              ) 搜尋
    b-row(
      no-gutters
      class="mb-3 px-2 button-row"
    )
      b-col(
        cols=3
      )
        b-button.button-first(
          block,
          :variant=" nowSelect === 'checking' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('checking')"
        ) 確認中
      b-col(
        cols=3
      )
        b-button(
          block,
          :variant=" nowSelect === 'checked' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('checked')"
        ) 已確認
      b-col(
        cols=3
      )
        b-button(
          block,
          :variant=" nowSelect === 'success' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('success')"
        ) 預約完成
      b-col(
        cols=3
      )
        b-button.button-last(
          block,
          :variant=" nowSelect === 'expired' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('expired')"
        ) 已過期
    .px-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(reservation,index) in reservations",
        :key="reservation.reservation_id"
      )
        .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
          .col-6.pr-1
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="reservation.picture_url",
              :style="{ 'width': '80px', 'height': '80px' }"
            )
          .col-6.pl-1
            p.mb-0.font-weight-bold 暱稱名 {{ reservation.line_name }}
            p.mb-0 備註名 {{ reservation.note_name }}
        .reserveAtRow.mb-2.d-flex.align-items-center
          i.far.fa-calendar-check.mr-2
          small 預約時間：{{ reservation.reserve_date }} {{ reservation.start_time }} ~ {{ reservation.end_time }}
        .typeRow.mb-2.d-flex.align-items-center
          i.fas.fa-border-all.mr-2
          small 服務內容：{{ reservation.reserve_type_name }}
        .statusRow.mb-2.d-flex.align-items-center
          i.far.fa-check-circle.mr-2
          small 預約狀態：{{ reservation.status === 'checked' ? '已確認' : reservation.status === 'checking' ? '確認中' : reservation.status === 'success' ? '預約完成' : reservation.status === 'expired' ? '已過期' : '-' }}
        .labelRow.d-flex.align-items-center.flex-wrap.mb-3
          i.fas.fa-tag.mr-2
          small 顧客標籤：
          b-badge.m-1.rounded-50.px-3.py-2(
            variant="primary",
            v-for="(label,index) in reservation.personnel_tags"
            :key="index"
          ) {{ label }}
        b-row(
          no-gutters
        )
          b-col(
            :cols="4",
            class="d-flex justify-content-end",
            v-if="reservation.status === 'checked'"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="cancelReservationHandler(reservation.reservation_id)"
            ) 取消預約
          b-col(
            cols=4,
            class="d-flex justify-content-center",
            v-if="reservation.status === 'checked'"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="editReservationHandler(reservation)"
            ) 修改預約
          b-col(
            cols=12,
            class="d-flex justify-content-center",
            v-if="reservation.status === 'checking'"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="confirmReservationHandler(reservation.reservation_id)"
            ) 預約確認
          b-col(
            cols=4,
            class="pl-1",
            v-if="reservation.status === 'checked'"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="doneReservationHandler(reservation.reservation_id)"
            ) 完成預約
        .labelTag(
          v-if="reservation.status === 'expired'",
          style="right: 0;bottom: 0;"
        )
          span.labelTag__text 已過期
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SA_RESERVATION_EDIT } from '@/router/sa/reservation';

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      searchInput: {
        customer_name: null,
        reservation_date: null
      },
      nowSelect: 'checking',
      infiniteId: +new Date()
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sa_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('sa_reservation/getReservationTimeListHandler');
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sa_reservation/getReservationHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        status: vm.nowSelect,
        customer_name: vm.searchInput.customer_name,
        reservation_date: vm.searchInput.reservation_date
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'checked':
          if (vm.nowSelect === 'checked') return;
          vm.nowSelect = 'checked';
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checking':
          if (vm.nowSelect === 'checking') return;
          vm.nowSelect = 'checking';
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelect === 'success') return;
          vm.nowSelect = 'success';
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelect === 'expired') return;
          vm.nowSelect = 'expired';
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    cancelReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '取消預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/deleteHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '取消確認成功');
        });
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          editInfo: reservation
        }
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '預約確認中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/checkHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '預約確認成功');
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '完成預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/successHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '完成預約成功');
        });
    },
    searchHandler() {
      const vm = this;
      if (!vm.searchInput.customer_name && !vm.searchInput.reservation_date) return;
      vm.$store.commit('sa_reservation/resetHandler');
      vm.infiniteId += 1;
    },
    researtSearchHandler() {
      const vm = this;
      vm.searchInput.customer_name = null;
      vm.searchInput.reservation_date = null;
      vm.$store.commit('sa_reservation/resetHandler');
      vm.infiniteId += 1;
    }
  },
  computed: {
    ...mapState({
      reservations: (state) => state.sa_reservation.reservations,
      reservationTimeList: (state) => state.sa_reservation.reservationTimeList,
      pagination: (state) => state.sa_reservation.pagination
    })
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
